import { render } from "./MoscowCityTower.vue?vue&type=template&id=a897286a&scoped=true"
import script from "./MoscowCityTower.vue?vue&type=script&lang=js"
export * from "./MoscowCityTower.vue?vue&type=script&lang=js"

import "./MoscowCityTower.vue?vue&type=style&index=0&id=a897286a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kvr\\Documents\\git\\krovyaka_io_source\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a897286a"]])

export default __exports__